import { render, staticRenderFns } from "./SmartDisplayC.vue?vue&type=template&id=99d4304c&scoped=true"
import script from "./SmartDisplayC.vue?vue&type=script&setup=true&lang=js"
export * from "./SmartDisplayC.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d4304c",
  null
  
)

export default component.exports